export default Object.freeze({
    car: 'car',
    bike: 'bike'
});
